export type ContractStatusDisplay = {
  kind:
    | "pending"
    | "draft"
    | "esigned"
    | "uploaded"
    | "attached"
    | "missing"
    | "sent"
    | "status";
  text: string;
};

type ContractStatusRow = {
  status: string;
  expiredStatus?: string;
  envelopeId?: string | null;
  hasSignedDocument?: boolean;
  signedDate?: string | Date | null;
};

const formatDate = (value: string | Date) => new Date(value).toLocaleDateString();

export function getContractStatusDisplay(row: ContractStatusRow): ContractStatusDisplay {
  if (row.status === "DRAFT") {
    return { kind: "draft", text: "Draft" };
  }
  if (row.status === "PENDING") {
    return { kind: "pending", text: row.expiredStatus ?? "" };
  }
  if (row.hasSignedDocument) {
    const signed = row.signedDate ? formatDate(row.signedDate) : "Signed";
    return row.status === "COMPLETED"
      ? { kind: "uploaded", text: signed }
      : { kind: "attached", text: `${signed} \u00b7 not completed` };
  }
  if (row.envelopeId && row.status === "COMPLETED") {
    return { kind: "esigned", text: row.signedDate ? formatDate(row.signedDate) : "Signed" };
  }
  if (row.envelopeId && row.status === "SENT") {
    return { kind: "sent", text: "Awaiting signature" };
  }
  if (row.status === "COMPLETED") {
    return { kind: "missing", text: "Contract info missing" };
  }
  return {
    kind: "status",
    text: row.status.charAt(0) + row.status.slice(1).toLowerCase(),
  };
}

export function ContractStatusCell({ rowData }: { rowData: ContractStatusRow }) {
  const display = getContractStatusDisplay(rowData);

  const icon =
    display.kind === "esigned" ? "pi pi-check-circle" :
    display.kind === "uploaded" || display.kind === "attached" ? "pi pi-paperclip" :
    display.kind === "missing" ? "pi pi-exclamation-triangle" : undefined;

  return (
    <span
      style={{
        display: "inline-flex", alignItems: "center", gap: "0.35rem",
        ...(display.kind === "missing" ? { color: "var(--orange-500, #f59e0b)" } : {}),
        ...(display.kind === "esigned" ? { color: "var(--green-600, #16a34a)" } : {}),
      }}
    >
      {icon ? <i className={icon} /> : null}
      {display.text}
    </span>
  );
}
